module.exports = {"540323100":"桑多镇","540323101":"类乌齐镇","540323200":"吉多乡","540323201":"岗色乡","540323202":"宾达乡","540323203":"卡玛多乡","540323204":"尚卡乡","540323205":"伊日乡","540323206":"甲桑卡乡","540323207":"长毛岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540323.json
// module id = 2512
// module chunks = 0